import { render } from "./App.vue?vue&type=template&id=adb096ca"
const script = {}

import "./App.vue?vue&type=style&index=0&id=adb096ca&lang=css"
script.render = render

export default script